export default __webpack_public_path__ + "static/media/new-3.f9e0d63f.png";